import React from "react";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useActiveProject } from "@/utils/utils";
import { useNavigate } from "react-router";

interface Props {
  provider: "Github" | "GitLab" | "Bitbucket";
}

const GitProviderAccessModal: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const project = useActiveProject();

  return (
    <AlertDialog open={true}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            You don't have access on {props.provider}
          </AlertDialogTitle>
          <AlertDialogDescription>
            You are a member of this Tempo project, but don't have access to the
            project on {props.provider}. Please ask the project owner to grant
            you access to:{" "}
            <code className="relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold">
              {project?.repoPath}
            </code>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => {
              navigate("/");
            }}
          >
            Close project
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default React.memo(GitProviderAccessModal);
